module.exports = __webpack_public_path__ + "static/media/danger.3aa9a2a2.svg";